import React from 'react';
import { ClockIcon, CoffeeIcon, RotateCcwIcon, XIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { Reveal } from '../Reveal';
import { hardCosts, painList } from '../../data/programa';
const icons = {
  clock: ClockIcon,
  coffee: CoffeeIcon,
  loop: RotateCcwIcon
} as const;
export function PainPoints() {
  return <section id="diagnostico" className="border-b border-line bg-carbon py-[60px] lg:py-[100px]" data-id="element-167" data-mp="22thhqrrtjw9x">
      <div className="mx-auto max-w-content px-6 lg:px-10" data-id="element-168" data-mp="2cldrx176jcui">
        <SectionHeading eyebrow="El diagnóstico" title={<span className="text-gold" data-id="element-170" data-mp="2qk53afunqkey">
              ¿Cuántos lunes más vas a empezar ya fundido?
            </span>} description="No es falta de voluntad. Tu biología no fue diseñada para 8 horas frente a una pantalla — y nunca te dieron el manual." data-id="element-169" data-mp="2ckvkd8f2hc7a" />

        <ul className="mx-auto mt-12 grid max-w-4xl gap-3 sm:grid-cols-2" data-id="element-171" data-mp="s623xp53za16">
          {painList.map((item, index) => <Reveal key={item} delay={index * 0.04} as="li" className="h-full" data-id="element-172" data-mp="1n94p87a30p39" data-mpi={index}>
              <div className="flex h-full items-start gap-3 rounded-2xl border border-alert/40 bg-alert/10 px-5 py-4" data-id="element-173" data-mp="1s64wglio3xvy">
                <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-alert" strokeWidth={2.5} aria-hidden="true" data-id="element-174" data-mp="1x57q79t76hom" />
                <span className="text-[15px] leading-[1.6] text-ice" data-id="element-175" data-mp="26wkig2iwr9v6">
                  {item}
                </span>
              </div>
            </Reveal>)}
        </ul>

        <Reveal delay={0.08} className="mx-auto mt-12 max-w-4xl" data-id="element-176" data-mp="2fwqtziv1pzrp">
          <p className="text-center text-[12px] font-medium uppercase tracking-[0.1em] text-gold" data-id="element-177" data-mp="2fueav2djxjd2">
            Lo que ese ciclo te cuesta
          </p>
          <ul className="mt-6 grid gap-4 sm:grid-cols-3" data-id="element-178" data-mp="lj9f0k8pib8a">
            {hardCosts.map(cost => {
            const Icon = icons[cost.icon as keyof typeof icons];
            return <li key={cost.stat} className="glass h-full p-5 text-left" data-id="element-179" data-mp="igbnx80rrbi6">
                  <Icon className="h-5 w-5 text-gold" strokeWidth={1.5} aria-hidden="true" data-id="element-180" data-mp="ef9mckjdqnd1" />
                  <p className="mt-3 text-xl font-bold tracking-tight text-ice" data-id="element-181" data-mp="sgc5opizpjk9">
                    {cost.stat}
                  </p>
                  <p className="mt-1.5 text-[13px] leading-[1.55] text-cool" data-id="element-182" data-mp="11fh846xo9x1p">
                    {cost.label}
                  </p>
                </li>;
          })}
          </ul>
        </Reveal>

        <Reveal delay={0.12} data-id="element-183" data-mp="1b624rotscrhz">
          <p className="mt-12 text-center text-2xl font-bold tracking-tight text-gold sm:text-3xl" data-id="element-184" data-mp="1b50pt99nfkuz">
            ¿Y si este fuera el último lunes que empezás así?
          </p>
        </Reveal>
      </div>
    </section>;
}